import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Acompanhamento from '../../components/Protetico/Acompanhamento'

const mapStateToProps = (store) => ({})

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Acompanhamento)
